/* Olphatelier — comportements de l'en-tête : méga-menu, carrousel, tiroir mobile, recherche, en-tête fixe. */
if (!customElements.get('ol-header')) {
  class OlHeader extends HTMLElement {
    connectedCallback() {
      this.desktop = window.matchMedia('(min-width: 1200px)');
      this.announcement = this.querySelector('.ol-announcement');
      this.drawerToggle = this.querySelector('[data-ol-drawer-toggle]');
      this.drawer = this.querySelector('[data-ol-drawer]');
      this.searchToggle = this.querySelector('[data-ol-search-toggle]');
      this.mobileSearch = this.querySelector('#OlMobileSearch');

      this.initSticky();
      this.initMega();
      this.initCarousels();
      this.initDrawer();
      this.initPlaceholders();

      this.desktop.addEventListener('change', () => {
        this.closeDrawer();
        this.closeMega();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (this.openItem) {
          const trigger = this.openItem.querySelector('[data-ol-mega-trigger]');
          this.closeMega();
          trigger?.focus();
        }
        if (!this.drawer.hidden) {
          this.closeDrawer();
          this.drawerToggle.focus();
        }
      });
    }

    initSticky() {
      const setHeight = () => {
        const height = this.announcement ? this.announcement.offsetHeight : 0;
        (this.closest('.shopify-section') || this).style.setProperty('--ol-ann-h', `${height}px`);
        this.annHeight = height;
      };
      const onScroll = () => this.classList.toggle('is-stuck', window.scrollY > this.annHeight + 2);
      setHeight();
      onScroll();
      window.addEventListener('resize', setHeight, { passive: true });
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    initMega() {
      this.querySelectorAll('.ol-nav__item--mega').forEach((item) => {
        const trigger = item.querySelector('[data-ol-mega-trigger]');
        let timer;
        item.addEventListener('mouseenter', () => {
          if (!this.desktop.matches) return;
          clearTimeout(timer);
          timer = setTimeout(() => this.openMega(item), 80);
        });
        item.addEventListener('mouseleave', () => {
          clearTimeout(timer);
          timer = setTimeout(() => this.closeMega(item), 180);
        });
        // Premier clic (ou toucher) : ouvre le menu. Deuxième clic : suit le lien.
        trigger.addEventListener('click', (event) => {
          if (this.openItem !== item) {
            event.preventDefault();
            this.openMega(item);
          }
        });
        item.addEventListener('focusout', (event) => {
          if (!item.contains(event.relatedTarget)) this.closeMega(item);
        });
      });
      document.addEventListener('click', (event) => {
        if (this.openItem && !this.openItem.contains(event.target)) this.closeMega();
      });
    }

    openMega(item) {
      if (this.openItem && this.openItem !== item) this.closeMega();
      const panel = item.querySelector('[data-ol-mega]');
      panel.hidden = false;
      item.classList.add('is-open');
      item.querySelector('[data-ol-mega-trigger]').setAttribute('aria-expanded', 'true');
      this.openItem = item;
      panel.querySelectorAll('[data-ol-carousel]').forEach((carousel) => carousel.update?.());
    }

    closeMega(item = this.openItem) {
      if (!item) return;
      item.querySelector('[data-ol-mega]').hidden = true;
      item.classList.remove('is-open');
      item.querySelector('[data-ol-mega-trigger]').setAttribute('aria-expanded', 'false');
      if (this.openItem === item) this.openItem = null;
    }

    initCarousels() {
      this.querySelectorAll('[data-ol-carousel]').forEach((carousel) => {
        const track = carousel.querySelector('[data-ol-track]');
        const prev = carousel.querySelector('[data-ol-prev]');
        const next = carousel.querySelector('[data-ol-next]');
        const bar = carousel.querySelector('[data-ol-progress]');
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          const ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
          bar.style.width = `${Math.min(ratio, 1) * 100}%`;
          bar.style.transform = `translateX(${max > 0 ? (track.scrollLeft / max) * (1 / Math.min(ratio, 1) - 1) * 100 : 0}%)`;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= max - 2;
        };
        const step = () => track.clientWidth * 0.8;
        prev.addEventListener('click', () => track.scrollBy({ left: -step() }));
        next.addEventListener('click', () => track.scrollBy({ left: step() }));
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update, { passive: true });
        carousel.update = update;
        update();
      });
    }

    initDrawer() {
      this.drawerToggle.addEventListener('click', () => {
        this.drawer.hidden ? this.openDrawer() : this.closeDrawer();
      });
      this.searchToggle.addEventListener('click', () => {
        const open = this.mobileSearch.hidden;
        if (open) this.closeDrawer();
        this.mobileSearch.hidden = !open;
        this.searchToggle.setAttribute('aria-expanded', String(open));
        if (open) this.mobileSearch.querySelector('input[type=search]').focus();
      });
    }

    openDrawer() {
      this.mobileSearch.hidden = true;
      this.searchToggle.setAttribute('aria-expanded', 'false');
      this.drawer.hidden = false;
      this.drawerToggle.setAttribute('aria-expanded', 'true');
      this.drawerToggle.setAttribute('aria-label', 'Fermer le menu');
      this.classList.add('is-drawer-open');
      document.documentElement.classList.add('ol-lock');
    }

    closeDrawer() {
      if (!this.drawer) return;
      this.drawer.hidden = true;
      this.drawerToggle.setAttribute('aria-expanded', 'false');
      this.drawerToggle.setAttribute('aria-label', 'Ouvrir le menu');
      this.classList.remove('is-drawer-open');
      document.documentElement.classList.remove('ol-lock');
    }

    initPlaceholders() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.querySelectorAll('[data-ol-placeholders]').forEach((input) => {
        const texts = input.dataset.olPlaceholders.split(',').map((text) => text.trim()).filter(Boolean);
        if (texts.length < 2) return;
        let index = 0;
        setInterval(() => {
          if (document.activeElement === input || input.value) return;
          input.classList.add('is-fading');
          setTimeout(() => {
            index = (index + 1) % texts.length;
            input.placeholder = texts[index];
            input.classList.remove('is-fading');
          }, 250);
        }, 3000);
      });
    }
  }
  customElements.define('ol-header', OlHeader);
}